import { IndexPageBase } from '@flipdish/api-client-typescript';
import { ExpansionPanel, ExpansionPanelSummary, makeStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Field, FieldProps } from 'formik';
import React, { memo } from 'react';
import { Translate } from 'react-localize-redux';

import EditWebsiteSettingsContactFormPanelForm from './EditWebsiteSettingsContactFormPanelForm';
import usePanelHandler, { PanelProps } from './usePanelHandler';

const useStyles = makeStyles({
  header: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

type Props = PanelProps & {
  settings: IndexPageBase;
};

export default memo(function EditWebsiteSettingsContactFormPanel(props: Props) {
  const { name, onToggle, expanded, onExpand, settings, className } = props;
  const classes = useStyles();
  const { handleExpanding } = usePanelHandler(name, onExpand);

  return (
    <ExpansionPanel className={className} onChange={handleExpanding} expanded={expanded}>
      <ExpansionPanelSummary
        classes={{ content: classes.header }}
        expandIcon={<ExpandMoreIcon />}
        IconButtonProps={{ 'data-fd': 'contact-form-toggle' }}
        aria-controls="contact_form"
      >
        <Translate id="Contact_form" />
        <Field name="ContactFormEnabled">
          {(fProps: FieldProps) => {
            const { field, form } = fProps;

            return (
              <Switch
                value=""
                color="default"
                data-fd="website_settings_contact_form_toggle"
                checked={field.value}
                onClick={(e) => e.stopPropagation()}
                onChange={(e, value: boolean) => {
                  form.setFieldValue(field.name, value);
                  if (onToggle) {
                    onToggle(name);
                  }
                }}
              />
            );
          }}
        </Field>
      </ExpansionPanelSummary>
      <EditWebsiteSettingsContactFormPanelForm settings={settings} />
    </ExpansionPanel>
  );
});
